import { useDynamicContext } from '@dynamic-labs/sdk-react-core';
import { useCallback, useEffect, useState } from 'react';

// import { checkGate } from '../check-gate';

export interface TokenGatingArgs {
  queries: string[];
}

export interface TokenGatingResult {
  result: boolean;
  loading: boolean;
}

/**
 * Custom hook to perform token gating checks based on provided queries.
 * @function useTokenGating
 * @param {TokenGatingArgs} args - The arguments for the token gating check.
 * @param {string[]} args.queries - The list of queries to check for token gating.
 * @returns {TokenGatingResult} An object containing the result of the token gating check and the loading state.
 */
export const useTokenGating = ({
  queries,
}: TokenGatingArgs): TokenGatingResult => {
  const { user } = useDynamicContext();
  const [result, setResult] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  /**
   * Performs the token gating check.
   * @function performCheck
   * @returns {Promise<void>}
   */
  const performCheck = useCallback(async () => {
    if (!user || loading === false) {
      return;
    }

    if (!queries.length) {
      setResult(true);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const hasAccess = [true];

      // await Promise.all(
      //   queries.map((query) => checkGate(query, user.verifiedCredentials)),
      // );

      setResult(hasAccess.includes(true));
    } catch (error) {
      console.error('Error checking gates:', error);
      setResult(false);
    } finally {
      setLoading(false);
    }
  }, [user, queries, loading]);

  useEffect(() => {
    performCheck();
  }, [performCheck]);

  return { result, loading };
};
